export const clearInputs = (type: string) => {
  // Some components have their own state and don't detect value changes. Must clear manually
  const inputs = document.querySelectorAll(`input[type=${type}]`);
  inputs.forEach((input: Element) => {
    if (input) {
      // @ts-expect-error
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      nativeInputValueSetter?.call(input, '');
      const event = new Event('input', { bubbles: true });
      input.dispatchEvent(event);
    }
  });
};

export const limitInputNumber = (e: React.KeyboardEvent<HTMLInputElement>) =>
  ['e', 'E', '+', '-', '.', ','].includes(e.key) && e.preventDefault();
